import styled from 'styled-components'
import { Link } from 'gatsby'

export const StyledLink = styled(Link)`
  font-family: Cinzel, serif;
  font-weight: 600;
  color: white;
  text-decoration: none;
  letter-spacing: 0.1rem;
  font-size: 1.75rem;
  text-shadow: 1px 1px #1F1F1F;
`
